angular.module('gym.invoices').controller('ProcessPaymentCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "$timeout", "CreditCardExpirationDatesService", "CreditCardValidationService", "PaymentProvidersService", "invoice", "paymentMethods", function($scope, $rootScope, $modalInstance, $http, $timeout, CreditCardExpirationDatesService, CreditCardValidationService, PaymentProvidersService, invoice, paymentMethods) {
  var cardElement, cardReady, elements, generatePaymentIntent, gym, initEzidebit, initStripeElements, onEzidebitSubmit, onEzidebitSubmitError, parseStripeErrorMessage, paymentIntentData, setEzidebitStatus, setStripeStatus, stripe;
  gym = $rootScope.gym;
  $scope.currency = gym.currency_symbol;
  $scope.invoice = invoice;
  $scope.amount = invoice.credit_applied_amount ? (invoice.amount - invoice.credit_applied_amount).toFixed(2) : invoice.amount;
  $scope.usesStripe = gym.uses_stripe;
  $scope.usesEzidebit = gym.uses_ezidebit;
  $scope.creditCardExists = $scope.usesStripe ? paymentMethods.length > 0 : !!paymentMethods.find(function(item) {
    return item.payment_method === 'credit_card';
  });
  $scope.params = {
    paymentOption: ($scope.creditCardExists && 'existing_card') || 'new_card'
  };
  stripe = null;
  elements = null;
  cardElement = null;
  cardReady = false;
  paymentIntentData = null;
  $scope.years = CreditCardExpirationDatesService.getYears();
  $scope.months = CreditCardExpirationDatesService.getMonths();
  $scope.card = {};
  initStripeElements = function() {
    var paymentAccount;
    paymentAccount = PaymentProvidersService.get('stripe');
    if (!(paymentAccount != null ? paymentAccount.public_key : void 0)) {
      return;
    }
    stripe = Stripe(paymentAccount.public_key);
    elements = stripe.elements();
    cardElement = elements.create('card');
    $timeout(function() {
      return cardElement.mount('#stripe-card-element');
    });
    return cardElement.on('change', function(event) {
      return $timeout(function() {
        var displayErrorEl;
        cardReady = event.complete;
        $scope.errorMessage = '';
        displayErrorEl = document.getElementById('stripe-card-errors');
        if (displayErrorEl != null) {
          if (event.error) {
            return displayErrorEl.textContent = event.error.message;
          } else {
            return displayErrorEl.textContent = '';
          }
        }
      });
    });
  };
  generatePaymentIntent = function() {
    var url;
    if (paymentIntentData) {
      return;
    }
    url = `/gyms/${gym.id}/stripe_retries/${invoice.id}/generate_payment_intent`;
    return $http.put(url).then(function(response) {
      return paymentIntentData = response.data;
    }, function(error) {
      return $scope.errorMessage = parseStripeErrorMessage(error);
    });
  };
  parseStripeErrorMessage = function(error) {
    var match, ref, ref1;
    if (typeof error.data === 'string') {
      if (error.data.includes('Stripe::PermissionError')) {
        return 'Payment processing is not available. Please contact support.';
      }
      if (error.data.includes('Stripe::InvalidRequestError')) {
        return 'Invalid payment request. Please try again.';
      }
      if (error.data.includes('Stripe::AuthenticationError')) {
        return 'Payment authentication failed. Please contact support.';
      }
      if (error.data.includes('Stripe::APIConnectionError')) {
        return 'Unable to connect to payment provider. Please try again later.';
      }
      if (error.data.includes('Stripe::CardError')) {
        match = error.data.match(/message:\s*["']([^"']+)["']/);
        return (match != null ? match[1] : void 0) || 'Your card was declined. Please try a different card.';
      }
      return 'An error occurred while processing your payment. Please try again.';
    }
    if ((ref = error.data) != null ? ref.message : void 0) {
      return error.data.message;
    }
    if ((ref1 = error.data) != null ? ref1.error : void 0) {
      return error.data.error;
    }
    return 'An unexpected error occurred. Please try again.';
  };
  initEzidebit = function() {
    var paymentAccount;
    paymentAccount = PaymentProvidersService.get('ezidebit');
    return $timeout(function() {
      window.initEziDebit();
      return eziDebit.init(paymentAccount.public_key, {
        submitAction: "ChargeCard",
        submitButton: "process-payment-button",
        submitCallback: onEzidebitSubmit,
        submitError: onEzidebitSubmitError,
        nameOnCard: "nameOnCard",
        cardNumber: "cardNumber",
        cardExpiryMonth: "expiryMonth",
        cardExpiryYear: "expiryYear",
        cardCCV: "ccv",
        paymentAmount: "processAmount",
        paymentReference: "paymentReference"
      }, paymentAccount.payment_system_url);
    });
  };
  $scope.checkCardNumber = function() {
    var ref;
    $scope.card.number = (ref = $scope.card.number) != null ? ref.replace(/[^0-9]/g, '') : void 0;
    return $scope.cardNumberValid = CreditCardValidationService.check($scope.card.number);
  };
  onEzidebitSubmit = function(response) {
    return $timeout(function() {
      if (response.PaymentResult === 'F') {
        setEzidebitStatus(response.BankReceiptID, response.PaymentResult, 'Failed. Payment was rejected by the bank.');
      }
      if (response.PaymentResult === 'U') {
        $scope.errorMessage = 'Payment cannot be submitted to the bank at this time. Please try again later.';
        $scope.isLoading = false;
        return;
      }
      if (response.PaymentResult === 'A') {
        return setEzidebitStatus(response.BankReceiptID, response.PaymentResult, null);
      }
    });
  };
  setEzidebitStatus = function(receiptId, paymentResult, paymentFailureMessage) {
    var params, url;
    params = {
      payment_result: paymentResult,
      bank_receipt_id: receiptId
    };
    url = `/gyms/${gym.id}/ezidebit_retries/${invoice.id}/set_status`;
    return $http.put(url, params).then(function(data) {
      if (paymentResult === 'A') {
        return $modalInstance.close();
      } else {
        $scope.errorMessage = paymentFailureMessage;
        return $scope.isLoading = false;
      }
    }, function(response) {
      return $scope.errorMessage = response.data.message;
    });
  };
  onEzidebitSubmitError = function(error) {
    return $timeout(function() {
      $scope.errorMessage = error;
      return $scope.isLoading = false;
    });
  };
  setStripeStatus = function(paymentSuccess) {
    var params, url;
    url = `/gyms/${gym.id}/stripe_retries/${invoice.id}/set_status`;
    params = {
      payment_success: paymentSuccess
    };
    return $http.put(url, params).then(function(data) {
      return $modalInstance.close();
    }, function(error) {
      $scope.errorMessage = parseStripeErrorMessage(error);
      return $scope.isLoading = false;
    });
  };
  $scope.isFormValid = function() {
    if ($scope.usesStripe) {
      return cardReady;
    } else {
      return $scope.cardNumberValid && $scope.card.cardholderName && $scope.card.expirationMonth && $scope.card.expirationYear && $scope.card.ccv;
    }
  };
  $scope.onPaymentOptionChange = function() {
    $scope.errorMessage = '';
    if ($scope.usesStripe && $scope.params.paymentOption === 'new_card' && !paymentIntentData) {
      return generatePaymentIntent();
    }
  };
  $scope.onCardSubmitted = function() {
    $scope.errorMessage = '';
    return $scope.isLoading = true;
  };
  $scope.processNow = function() {
    var url;
    $scope.errorMessage = '';
    $scope.isLoading = true;
    if ($scope.usesStripe) {
      url = `/gyms/${gym.id}/stripe_retries/${invoice.id}/process_now`;
    } else {
      url = `/gyms/${gym.id}/ezidebit_retries/${invoice.id}/process_now`;
    }
    return $http.put(url).then(function(data) {
      return $modalInstance.close();
    }, function(error) {
      if ($scope.usesStripe) {
        $scope.errorMessage = parseStripeErrorMessage(error);
      } else {
        $scope.errorMessage = error.data.message;
      }
      return $scope.isLoading = false;
    });
  };
  $scope.processWithNewCard = function() {
    $scope.errorMessage = '';
    $scope.isLoading = true;
    if (!paymentIntentData) {
      $scope.errorMessage = 'Payment form not ready. Please wait a moment and try again.';
      $scope.isLoading = false;
      return;
    }
    return stripe.confirmCardPayment(paymentIntentData.payment_intent_secret, {
      payment_method: {
        card: cardElement
      }
    }).then(function(result) {
      return $timeout(function() {
        if (result.error) {
          $scope.errorMessage = result.error.message || 'Payment failed. Please try again.';
          return $scope.isLoading = false;
        } else {
          return setStripeStatus(true);
        }
      });
    });
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  return $timeout(function() {
    if ($scope.usesStripe) {
      initStripeElements();
      if ($scope.params.paymentOption === 'new_card') {
        return generatePaymentIntent();
      }
    } else if ($scope.usesEzidebit) {
      return initEzidebit();
    }
  });
}]);
